var map = {
	"./achievements_select.svg": "7a12",
	"./buyafeature_select.svg": "e6f4",
	"./jackpots_select.svg": "0df0",
	"./scratch_select.svg": "63fa",
	"./tournaments_select.svg": "d8ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9b99";